import Reveal from "@/components/Reveal";
import {
  ListChecks, Megaphone, CalendarCheck, MessagesSquare, LogIn,
  Sparkles, Wrench, LineChart, Activity, FileBarChart,
} from "lucide-react";

const ITEMS = [
  { icon: ListChecks, text: "Short-term rental listing creation and optimization" },
  { icon: Megaphone, text: "Marketing across multiple booking platforms" },
  { icon: CalendarCheck, text: "Reservation and booking management" },
  { icon: MessagesSquare, text: "Guest communication and customer support" },
  { icon: LogIn, text: "Check-in and checkout coordination" },
  { icon: Sparkles, text: "Professional cleaning scheduling" },
  { icon: Wrench, text: "Maintenance and repair coordination" },
  { icon: LineChart, text: "Pricing and occupancy optimization" },
  { icon: Activity, text: "Property performance monitoring" },
  { icon: FileBarChart, text: "Monthly financial reporting" },
];

export default function Handles() {
  return (
    <section id="services" className="py-20 sm:py-28" data-testid="handles-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="max-w-3xl">
          <p className="text-sm font-bold tracking-[0.2em] uppercase text-[#FF5A5F]">Full-Service Management</p>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-[#222]">
            You Own the Property. We Handle the Hospitality.
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {ITEMS.map((item, i) => (
            <Reveal key={item.text} delay={(i % 3) * 0.06}>
              <div
                data-testid={`handles-item-${i + 1}`}
                className="flex items-center gap-4 bg-white border border-[#EBEBEB] rounded-2xl px-6 py-5 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_24px_rgba(0,0,0,0.08)]"
              >
                <span className="shrink-0 w-11 h-11 rounded-xl bg-[#FFD3C6]/60 flex items-center justify-center">
                  <item.icon className="w-5 h-5 text-[#E0484D]" />
                </span>
                <p className="text-[15px] font-semibold text-[#333] leading-snug">{item.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-10">
          <p className="text-sm sm:text-[15px] text-[#717171] max-w-3xl" data-testid="handles-owner-note">
            As the owner, you remain responsible for property ownership expenses, approved maintenance
            costs, and other agreed operating expenses — we take care of everything hospitality.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
